import React from "react";
import { Tab, Tabs } from "@jsq/ds/core";

/** Tab shared across all dashboard levels. */
export type DashboardTab = "summary" | "auditLog";

export const DashboardTabs = ({
  activeTab,
  onChange,
  auditLogDisabled = false,
}: {
  activeTab: DashboardTab;
  onChange: (tab: DashboardTab) => void;
  auditLogDisabled?: boolean;
}) => (
  <Tabs hasPaddingInline={false} hasBottomBorder={false}>
    <Tab
      text="AML/KYC summary"
      active={activeTab === "summary"}
      disabled={false}
      onClick={() => onChange("summary")}
    />
    <Tab
      text="Compliance activity"
      active={activeTab === "auditLog"}
      disabled={auditLogDisabled}
      onClick={() => onChange("auditLog")}
    />
  </Tabs>
);
